import type { IcebergInput } from "@shared/icebergLayout";
import type { FinancialsOverview } from "@/hooks/useFinancials";

const monthShort = (d: string) =>
  new Date(`${d.slice(0, 10)}T12:00:00Z`).toLocaleDateString("en-US", { month: "short", timeZone: "UTC" });

/** byClient is the fee per company; the pipeline rows supply stage and expected close for the label. */
export function icebergInputs(data: FinancialsOverview, includeUpside: boolean): IcebergInput[] {
  const meta = new Map<string, { stage: string | null; close: string | null }>();
  for (const c of data.pipeline.clients) meta.set(c.companyId, { stage: c.stage, close: c.expectedCloseOn });
  for (const p of data.pipeline.prospects) meta.set(p.companyId, { stage: p.stage, close: p.expectedCloseOn });
  return data.byClient
    .filter((b) => includeUpside || b.bucket !== "upside")
    .map((b) => {
      const m = meta.get(b.companyId);
      const sub = [m?.stage ?? "No stage", m?.close ? monthShort(m.close) : null].filter(Boolean).join(" · ");
      return { id: b.companyId, name: b.name, amount: b.amount, tier: b.bucket, sub };
    });
}
